@if (tableConfig) {
  @if (showToggle) {
    <div class="flex justify-end mb-2">
      <div class="text-sm text-gray-600 flex items-center gap-2">
        <span>
          {{ 'dashboard.servicerequest.complete.displayprocessed' | translate }}
        </span>

        <form [formGroup]="form">
          <app-toggle formControlName="processedRequests"></app-toggle>
        </form>
      </div>
    </div>
  }
  <app-table
    #table
    [config]="tableConfig"
    [(selectedElements)]="selectedElements">
  </app-table>
}
